import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, ValidationErrors} from '@angular/forms';
import {AddressComponent} from '@shared/form-components/address/address.component';
import {ReferenceApplicantModel} from '@service/models/applicant.model';
import {getInstitutionId} from '../../../constants/constant';
import {environment} from '@env/environment';

@Component({
    selector: 'cs-reference-applicant',
    templateUrl: './reference-applicant.component.html',
    styleUrls: ['./reference-applicant.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ReferenceApplicantComponent),
        multi: true
    }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => ReferenceApplicantComponent),
        multi: true
    }]
})

export class ReferenceApplicantComponent implements ControlValueAccessor {
    @ViewChild(NgForm) f: NgForm;
    @ViewChild('address') address: AddressComponent;
    @Input('data-test-id') testId: string = 'reference-applicant';
    referenceApplicant: ReferenceApplicantModel = new ReferenceApplicantModel();
    institutionSettings = getInstitutionId(environment.env);
    cssWidthClass = this.institutionSettings.singleColumnLayout ? 'col-sm-12' : 'col-md-6';

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }

    runValidation() {
        this.f.form.markAllAsTouched();
        this.address?.touch();
    }

    registerOnChange(fn: any): void {
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(obj: ReferenceApplicantModel): void {
        this.referenceApplicant = obj;
    }

}
